module.exports = __webpack_public_path__ + "img/sharesmartDashboard.268b404d.png";